module.exports = __webpack_public_path__ + "90278b857451dd4694401e7e24db0f21.jpg";